module.exports = "//public.getcloudapp.com/packs/media/images/upload-copy-4e9c5ca1230d12887ba7f1f5f5a10dbd.png";